<template>
    <v-col cols="12">
        <span class="headline">Sajt</span>
        <bit-page :breadcrumbs="breadcrumbs"></bit-page>
        <v-row align="center" class="white mt-3 pa-3" no-gutters>
            <span class="title green--text text--darken-3">Sajt</span>
            <v-col class="d-flex mb-3" cols="12">
                <v-divider></v-divider>
            </v-col>
            <v-col cols="12" sm="6" class="px-2">
                <v-text-field
                        v-model="website.website"
                        dense
                        label="Naziv"
                        outlined
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="px-2">
                <v-text-field
                        v-model="website.url"
                        dense
                        label="URL"
                        outlined
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="px-2">
                <v-select clearable
                          :items="items"
                          v-model="website.parent"
                          dense
                          label="Roditelj"
                          outlined
                          item-value="id"
                          item-text="website"
                          return-object
                ></v-select>
            </v-col>
            <v-col cols="12" sm="6" class="px-2">
                <v-switch v-model="website.status" inset :label="website.status ? 'Aktivan' : 'Neaktivan'" class="mt-0"></v-switch>
            </v-col>
            <v-col cols="12">
                <v-divider></v-divider>
            </v-col>
            <v-col cols="12" class="mt-2">
                <v-row justify="center">
                    <v-btn color="primary" tile depressed @click="save">Snimi</v-btn>
                </v-row>
            </v-col>
        </v-row>

        <v-snackbar
                top
                v-model="snackbar"
        >
            Successfully
            <v-btn
                    color="pink"
                    text
                    @click="snackbar = false"
            >
                Close
            </v-btn>
        </v-snackbar>
    </v-col>
</template>

<script>
    import bitPage from "../../components/layout/page";

    export default {
        components: {
            bitPage
        },
        head() {
            return {
                title: 'BitLab CMS'
            }
        },
        data: () => ({
            breadcrumbs: [
                {
                    text: 'Sajtovi',
                    disabled: false,
                    to: {name: 'sajtovi'},
                },
                {
                    text: 'Dodavanje novog sajta',
                    disabled: true
                },
            ],
            headers: [
                {text: 'ID', value: 'id'},
                {text: 'Name', value: 'name'},
                {text: 'Code', value: 'code'},
                {text: 'Icon', value: 'icon'},
                {text: 'Option', value: 'option'}
            ],
            items: [],
            website: {
                website: null,
                url: null,
                parent: null,
                status: 0
            },
            snackbar: false
        }),
        created() {
            if(this.$route.params.item){
                this.website = this.$route.params.item;
            }

            this.getWebSite();
        },
        methods: {
            getWebSite() {
                this.loading = true;
                this.axios.get('/website').then(res => {
                    this.items = res.data
                }).finally(()=> this.loading = false)
            },
            save() {
                this.website.parent_id = this.website.parent && this.website.parent.id ? this.website.parent.id : 0
                if(this.$route.params.item && !this.$route.params.sub){
                    this.axios.put(`/website/${this.website.id}`, this.website).then(res => {
                        this.snackbar = true;
                        this.$router.push({name: 'sajtovi'});
                    })
                }
                else{
                    this.axios.post('/website', this.website).then(res => {
                        this.snackbar = true;
                        this.$router.push({name: 'sajtovi'});
                    })
                }
            }
        }
    }
</script>
